module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.pagination) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-aqua"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.pagination.totalCount))]), _vm._v(" "), _c('p', [_vm._v("Total Assignments")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "small-box-footer",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-green"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.pagination.currentPage))]), _vm._v(" "), _c('p', [_vm._v("Current Page")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('a', {
    staticClass: "small-box-footer",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-yellow"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.pagination.totalPages))]), _vm._v(" "), _c('p', [_vm._v("Total Pages")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('a', {
    staticClass: "small-box-footer",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-red"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.pagination.pageSize))]), _vm._v(" "), _c('p', [_vm._v("Records per Page")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('a', {
    staticClass: "small-box-footer",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" ")])])])]) : _vm._e(), _vm._v(" "), (_vm.pagination && _vm.pagination.totalCount > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('label', {
    staticClass: "mr-2 mb-0"
  }, [_vm._v("Show:")]), _vm._v(" "), _c('b-form-select', {
    staticClass: "w-auto",
    attrs: {
      "options": _vm.pageOptions,
      "size": "sm"
    },
    on: {
      "change": _vm.handlePerPageChange
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-muted"
  }, [_vm._v("entries")])], 1), _vm._v(" "), _c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "total-rows": _vm.pagination.totalCount,
      "per-page": _vm.perPage,
      "size": "sm",
      "first-number": "",
      "last-number": ""
    },
    on: {
      "change": _vm.changePage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-muted small"
  }, [_vm._v("\n              Showing " + _vm._s(_vm.records.length ? ((_vm.currentPage - 1) * _vm.perPage + 1) : 0) + " to " + _vm._s(Math.min(((_vm.currentPage - 1) * _vm.perPage) + _vm.records.length, _vm.pagination.totalCount || 0)) + " of " + _vm._s(_vm.pagination.totalCount || 0) + " entries\n            ")])], 1)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-default"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Assignment Details with Profit Loss")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportToExcel
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export Excel\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.records), function(record, index) {
    return _c('tr', {
      key: record.assignmentId,
      class: _vm.getRowClass(record)
    }, [_c('td', [_vm._v(_vm._s(((_vm.currentPage - 1) * _vm.perPage) + index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.assignmentId || 'N/A'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.jobSeries))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.jobNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.jobType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.transportType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.client))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.por))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.pol))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.pod))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.branch))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.RaisedBy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.shippingLine))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatCurrency(record.expenses)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatCurrency(record.incomes)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right",
      class: _vm.getProfitClass(record.profit)
    }, [_vm._v("\n                " + _vm._s(_vm.formatCurrency(record.profit)) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "text-right",
      class: _vm.getPercentageClass(record.profitPercentage)
    }, [_vm._v("\n                " + _vm._s(record.profitPercentage) + "%\n              ")]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "label",
      class: _vm.getStatusClass(record.status)
    }, [_vm._v("\n                  " + _vm._s(record.status) + "\n                ")])])])
  }))])]), _vm._v(" "), (_vm.records.length === 0) ? _c('div', {
    staticClass: "text-center text-muted"
  }, [_c('i', {
    staticClass: "fa fa-info-circle fa-2x"
  }), _vm._v(" "), _c('p', [_vm._v("No assignment data found for the selected filters.")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-list"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-book"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-table"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("SN")]), _vm._v(" "), _c('th', [_vm._v("Assignment ID")]), _vm._v(" "), _c('th', [_vm._v("Job Series")]), _vm._v(" "), _c('th', [_vm._v("Job No")]), _vm._v(" "), _c('th', [_vm._v("Job Type")]), _vm._v(" "), _c('th', [_vm._v("Transport Type")]), _vm._v(" "), _c('th', [_vm._v("Client")]), _vm._v(" "), _c('th', [_vm._v("POR")]), _vm._v(" "), _c('th', [_vm._v("POL")]), _vm._v(" "), _c('th', [_vm._v("POD")]), _vm._v(" "), _c('th', [_vm._v("Branch")]), _vm._v(" "), _c('th', [_vm._v("Raised By")]), _vm._v(" "), _c('th', [_vm._v("Shipping Line")]), _vm._v(" "), _c('th', [_vm._v("Expenses")]), _vm._v(" "), _c('th', [_vm._v("Incomes")]), _vm._v(" "), _c('th', [_vm._v("Profit")]), _vm._v(" "), _c('th', [_vm._v("Profit %")]), _vm._v(" "), _c('th', [_vm._v("Status")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b653ca7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/growthDashboard/AssignmentsGrowthComponent.vue
// module id = 2485
// module chunks = 0